// extracted by mini-css-extract-plugin
module.exports = {"header":"BbmuX","logo":"VN3Il","nav-item":"_3sXRf"};